import React from 'react';
import { Link } from 'react-router-dom';

interface LegalLinkProps {
  to: string;
  children: React.ReactNode;
}

export const LegalLink: React.FC<LegalLinkProps> = ({ to, children }) => {
  return (
    <Link 
      to={to}
      className="!text-[#F4F0E7] text-[15px] font-bold leading-[21px] tracking-[0.15px] hover:text-[#C3B89F] transition-colors"
    >
      {children}
    </Link>
  );
};
